import React, { useState, useEffect } from "react";
import { withRouter } from 'react-router-dom';
import { orderService } from "../../../services/order";
import TravelersList from "./TravelersList";
import TravelerConversation from "./TravelerConversation";
// import GroupConversation from "./GroupConversation";
import './ChatModule.css';

function ChatWrapper(props) {

    const [usersMap, setUsersMap] = useState({});
    const [sendersList, setSendersList] = useState([]);
    const [summary_chats, setSummaryChats] = useState([]);
    const [groups, setGroups] = useState([]);
    const [filteredGroups, setFilteredGroups] = useState([]);
    const [receiversList, setReceiversList] = useState([]);
    const [allReceiversList, setAllReceiversList] = useState([]);
    const [sender, setSender] = useState(undefined);
    const [receiver, setReceiver] = useState(undefined);
    const [groupChat, setGroupChat] = useState(undefined);
    const [order_id, setOrderId] = useState('');
    const [all_messages, setAllMessages] = useState([]);
    const [is_all_messages, setIsAllMessages] = useState(false);
    const [is_all_groups, setIsAllGroups] = useState(false);
    const [selectedSender, setSelectedSender] = useState(null);
    // const [orderSettings, setOrderSettings] = useState(null);
    const [isAllowOneToOneChat, setIsAllowOneToOneChat] = useState(0);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);


    async function getTravelersList() {
        try {
            setOrderId(props.match.params.order_id);
            const res = await orderService.getAllFollowingOrderUsers(props.match.params.order_id);
            const { summary_chats, users, usersMap, message_all_chats, order_settings } = res.result.data;
            setUsersMap(usersMap);
            setAllMessages(message_all_chats);
            if(order_settings && order_settings.is_allow_one_to_one_chat) { 
                // setOrderSettings(order_settings);
                const is_allow_one_to_one_chat = Number(order_settings.is_allow_one_to_one_chat.value);
                setIsAllowOneToOneChat(is_allow_one_to_one_chat);
            }

            
            
            const tempSenders = {};
            const tempReceivers = {};
            const tempMessages = {};
            let groups = {};
            summary_chats.forEach(chat => {
                if (chat.sent_by && chat.id.includes(chat.sent_by)) {
                    let user = usersMap[chat.sent_by];
                    if(!user || undefined == user) {
                        user = {
                            "firstName":chat.sender_first_name,
                            "lastName":chat.sender_last_name,
                            "sender_first_name":chat.sender_first_name,
                            "sender_last_name":chat.sender_last_name,
                            "userId": chat.sent_by,
                            "id": chat.sent_by,
                            "deviceType": chat.deviceType,
                            // "isAdmin": chat.isAdmin,
                            "type": chat.type,
                            "orderId": chat.orderId,
                            "deleted_at": chat.orderId,
                            // "location_permission": true,
                            // "status": "offline",
                        };
                    }
                    else {
                        // console.log('chat-------------', chat);
                    }
                    tempSenders[user.id] = {
                        ...user,
                        selected: false,
                        type: 'sender',
                    }
                }
                if (chat.received_by && chat.received_by.length > 1 && chat.id.includes(chat.received_by)) {
                    let user = usersMap[chat.received_by];
                    // let is_user_deleted = false;
                    if(!user || undefined == user) {
                        user = {
                            "firstName":chat.receiver_first_name,
                            "lastName":chat.receiver_last_name,
                            "receiver_first_name":chat.receiver_first_name,
                            "receiver_last_name":chat.receiver_last_name,
                            "userId": chat.received_by,
                            "id": chat.received_by,
                            "deviceType": chat.deviceType,
                            // "isAdmin": chat.isAdmin,
                            "type": chat.type,
                            "orderId": chat.orderId,
                            "deleted_at": chat.orderId,
                            // "location_permission": true,
                            // "status": "offline",
                        };
                    }
                    // console.log('user', user, chat.received_by);
                    tempReceivers[user.id] = {
                        ...user,
                        selected: false,
                        type: 'receiver',
                    }
                }

                if (chat.type == '2') {
                    groups[chat.id] = { ...chat }
                    chat.members.forEach(ch_mem => {
                        let user = usersMap[ch_mem];
                        if((user && undefined != user && chat.sent_by == ch_mem)) {
                            // console.log('missing data', ch_mem, chat);
                            // user = {
                            //     "firstName":chat.sender_first_name,
                            //     "lastName":chat.sender_last_name,
                            //     "sender_first_name":chat.sender_first_name,
                            //     "sender_last_name":chat.sender_last_name,
                            //     "userId": chat.sent_by,
                            //     "id": chat.sent_by,
                            //     // "deviceType": ch_mem.deviceType,
                            //     // "isAdmin": ch_mem.isAdmin,
                            //     "type": chat.type,
                            //     "orderId": chat.orderId,
                            //     "deleted_at": chat.orderId,
                            //     // "location_permission": true,
                            //     // "status": "offline",
                            // };
                            tempSenders[user.id] = {
                                ...user,
                                selected: false,
                                type: 'sender',
                            }
                        }
                    })
                }
            });
            const senders = [...Object.values(tempSenders)];
            const receivers = [...Object.values(tempReceivers)];
            // console.log('senders list', senders, tempSenders);
            // console.log('receivers list', receivers, tempReceivers);
            setSendersList(senders);
            setAllReceiversList(receivers);
            setGroups([...Object.values(groups)]);
            setSummaryChats(res.result.data.summary_chats);
            // console.log('Error in listing', summary_chats);
        } catch (e) {
            console.log('Error in listing', e);
        }
    }

    useEffect(() => {
        getTravelersList();
    }, []);

    function setSelectedGroup(group) {
        const temp = filteredGroups.map(grp => {
            if (grp.id === group.id)
                grp.selected = true;
            else
                grp.selected = false;
            return grp;
        })

        setFilteredGroups(temp);
        // console.log('group', group, temp);
        setGroupChat(group);
        const receivers = unselectAllItems(receiversList);
        setReceiversList(receivers);
        setReceiver(undefined);
    }

    function unselectAllItems(arr) {
        const temp = [...arr].map(item => {
            item.selected = false;
            return item;
        })
        return temp;
    }

    function handleSelectedSender(sender) {
        setSelectedSender(sender);
        if(sender == undefined || sender == null) {
            return true;
        }
        const temp = sendersList.map(tvl => {
            if (tvl.id === sender.id)
                tvl.selected = true;
            else
                tvl.selected = false;
            return tvl;
        })
        setSendersList(temp);
        setSender(sender);

        let receiver_ids = [];
        summary_chats.forEach(chat => {
            if (chat.sent_by === sender.id) {
                receiver_ids.push(chat.received_by);
            }
        })

        const temp_receiveres = [];
        allReceiversList.forEach(tvl => {
            if (receiver_ids.includes(tvl.id)) {
                temp_receiveres.push({ ...tvl });
            }
        })

        const filtered_groups = [];
        groups.forEach(group => {
            if (group.members.includes(Number(sender.id))) {
                filtered_groups.push({ ...group });
            }
        })

        setFilteredGroups(filtered_groups);
        setReceiversList(temp_receiveres);
        setReceiver(undefined);
        setGroupChat(undefined);
    }

    function setSelectedReceiver(receiver) {
        const groupsList = unselectAllItems(filteredGroups);
        setFilteredGroups(groupsList);
        setGroupChat(undefined);
        const temp = receiversList.map(tvl => {
            if (tvl.id === receiver.id)
                tvl.selected = true;
            else
                tvl.selected = false;
            return tvl;
        })
        setReceiversList(temp);
        setReceiver(receiver);
    }

    function allMessageHandler(state, index) {
        if (state) {
            setGroupChat(undefined);
            setIsAllMessages(undefined);
        }
        selectedTabIndexHandler(index)
        if(index == 1) {
            setIsAllMessages(state);
        }
        else if(index == 2){
            setIsAllGroups(state);
            // groups[0].selected = true;
            setSelectedGroup(groups[0]);

            // const temp = filteredGroups.map(grp => {
            //     if (grp.id === groups[0].id)
            //         grp.selected = true;
            //     else
            //         grp.selected = false;
            //     return grp;
            // })

            // setFilteredGroups(temp);
        }
    }

    function selectedTabIndexHandler(index) {
        setSelectedTabIndex(index);
    }

    return (
        <div>
            {
                (sendersList.length > 0 || groups.length > 0 || all_messages.length > 0) ?
                    // <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                    <div className="chat-wrapper">
                        <div className="col-sm-12 col-md-4">
                            <TravelersList
                                travelersList={sendersList}
                                all_messages={all_messages}
                                type={"senders"}
                                header={'Senders'}
                                usersMap={usersMap}
                                groups={groups}
                                setSelectedSender={handleSelectedSender}
                                setSelectedReceiver={setSelectedReceiver}
                                allMessageHandler={allMessageHandler}
                                selectedTabIndex={selectedTabIndex}
                                setSelectedGroup={setSelectedGroup}
                                setSender={setSender}
                                setReceiver={setReceiver}
                                setGroupChat={setGroupChat}
                                is_allow_one_to_one_chat={isAllowOneToOneChat}
                            />
                        </div>
                        {
                            // !is_all_messages && !is_all_groups &&
                            selectedTabIndex === 0 &&
                            <div className="col-sm-12 col-md-4">
                                <div className="listGroups">
                                <TravelersList
                                    travelersList={receiversList}
                                    header={'Receivers'}
                                    groups={filteredGroups}
                                    type={"receivers"}
                                    usersMap={usersMap}
                                    setSelectedSender={handleSelectedSender}
                                    setSelectedReceiver={setSelectedReceiver}
                                    setSelectedGroup={setSelectedGroup}
                                    selectedTabIndex={selectedTabIndex}
                                    setSender={setSender}
                                    setGroupChat={setGroupChat}
                                    is_allow_one_to_one_chat={isAllowOneToOneChat}
                                />
                                </div>
                            </div>
                        }
                        {
                            // (sender && receiver && !groupChat) ?
                            ((sender && receiver) || groupChat || (is_all_messages && all_messages) || (is_all_groups && groups)) ?
                                <div className="col-sm-12 col-md-4">
                                    <TravelerConversation
                                        sender={sender}
                                        receiver={receiver}
                                        groupChat={groupChat}
                                        summary_chats={summary_chats}
                                        order_id={order_id}
                                        all_messages={all_messages}
                                        is_all_messages={is_all_messages}
                                        is_all_groups={is_all_groups}
                                        usersMap={usersMap}
                                        getTravelersList={getTravelersList}
                                        selectedSender={selectedSender}
                                        selectedTabIndex={selectedTabIndex}
                                        is_allow_one_to_one_chat={isAllowOneToOneChat}
                                    />
                                </div>
                                :
                                <div className="col-sm-12 col-md-4">
                                </div>
                        }
                    </div>
                    :
                    <div style={{ minHeight: '500px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ fontSize: '3em', fontWeight: '200px' }}>
                            No Data Available
                        </div>
                        <div>
                            <button className="btn btn-primary" onClick={() => { props.history.goBack() }}>Go Back</button>
                        </div>
                    </div>
            }
        </div>
    );
}

export default withRouter(ChatWrapper);
